/**
 * Company phone number configuration
 * These phone numbers are now retrieved from Twilio API via the twilio-token bot
 * and are available in the TwilioPhoneProvider context as availableCallerIds
 */

export interface CompanyPhoneNumber {
  id: string;
  number: string;
  label: string;
  description?: string;
}

/**
 * Format a phone number for display
 * Converts +15551234567 to +1 (555) 123-4567
 */
export function formatPhoneNumberForDisplay(phoneNumber: string): string {
  // Remove all non-digit characters
  const cleaned = phoneNumber.replace(/\D/g, '');

  // Check if it's a US number (starts with 1 and has 11 digits)
  if (cleaned.length === 11 && cleaned[0] === '1') {
    const countryCode = cleaned[0];
    const areaCode = cleaned.substring(1, 4);
    const firstPart = cleaned.substring(4, 7);
    const secondPart = cleaned.substring(7, 11);
    return `+${countryCode} (${areaCode}) ${firstPart}-${secondPart}`;
  }

  // For other formats, just add the + prefix if missing
  return phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`;
}
